import { useState } from "react";

import type { DecryptedItem } from "../auth";
import { CopyButton } from "../components/CopyButton";
import { Identicon } from "../components/Identicon";
import { TotpDisplay } from "../components/TotpDisplay";

interface Props {
  item: DecryptedItem;
  onBack: () => void;
  onEdit: () => void;
  onToast: (msg: string) => void;
}

function hostFromUrl(url: string): string {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return "";
  }
}

export function Detail({ item, onBack, onEdit, onToast }: Props) {
  const [showPw, setShowPw] = useState(false);
  const d = item.data;
  const host = hostFromUrl(d.url);
  const seed = host || d.name || d.username || "?";

  return (
    <>
      <div className="header">
        <button className="back-btn" onClick={onBack} aria-label="Wstecz">
          ‹ Wstecz
        </button>
        <h1>{d.name || host || "(bez nazwy)"}</h1>
        <button className="back-btn" onClick={onEdit} aria-label="Edytuj">
          Edytuj
        </button>
      </div>

      <div className="main">
        <div className="detail-head">
          <Identicon seed={seed} size={64} />
          <h2>{d.name || host}</h2>
          {host && <div className="sub">{host}</div>}
        </div>

        {d.username && (
          <div className="field-card">
            <div className="field-text">
              <div className="field-label">Login</div>
              <div className="field-value text">{d.username}</div>
            </div>
            <CopyButton text={d.username} onCopy={() => onToast("Skopiowano login")} />
          </div>
        )}

        {d.password && (
          <div className="field-card">
            <div className="field-text">
              <div className="field-label">Hasło</div>
              <div className="field-value">{showPw ? d.password : "•".repeat(Math.min(d.password.length, 14))}</div>
            </div>
            <button
              type="button"
              className="toggle-btn"
              onClick={() => setShowPw(!showPw)}
              aria-label={showPw ? "Ukryj" : "Pokaż"}
            >
              {showPw ? "🙈" : "👁"}
            </button>
            <CopyButton text={d.password} onCopy={() => onToast("Skopiowano hasło")} />
          </div>
        )}

        {d.totp_secret && <TotpDisplay secret={d.totp_secret} onCopy={() => onToast("Skopiowano kod 2FA")} />}

        {d.url && (
          <div className="field-card">
            <div className="field-text">
              <div className="field-label">URL</div>
              <div className="field-value text">{d.url}</div>
            </div>
            <a href={d.url} target="_blank" rel="noreferrer" className="copy-btn" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
              Otwórz
            </a>
          </div>
        )}

        {d.notes && (
          <div className="field-card">
            <div className="field-text">
              <div className="field-label">Notatki</div>
              <div className="field-value text" style={{ whiteSpace: "pre-wrap" }}>
                {d.notes}
              </div>
            </div>
            <CopyButton text={d.notes} onCopy={() => onToast("Skopiowano notatki")} />
          </div>
        )}
      </div>
    </>
  );
}
